import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ModesVertHorCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("path", { stroke: "currentColor", strokeLinecap: "round", d: "M7.5 12.5H3M22 12.5h-4.5" }), _jsx("circle", { cx: 12.5, cy: 12.5, r: 4.5, stroke: "currentColor", transform: "rotate(90 12.5 12.5)" })] }) });
}
const ModesVertHorCustom = forwardRef(_ModesVertHorCustom);
export { ModesVertHorCustom };
